/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AccountRouteImport } from "./routes/account"
import { Route as AdminRouteImport } from "./routes/admin"
import { Route as PlatformHandoffRouteImport } from "./routes/platform-handoff"
import { Route as ResetRouteImport } from "./routes/reset"
import { Route as SigninRouteImport } from "./routes/signin"
import { Route as SignupRouteImport } from "./routes/signup"
import { Route as AdminIndexRouteImport } from "./routes/admin/index"
import { Route as AdminAuditRouteImport } from "./routes/admin/audit"
import { Route as AdminDataRouteImport } from "./routes/admin/data"
import { Route as AdminEmailMarketingRouteImport } from "./routes/admin/email-marketing"
import { Route as AdminLiveNowRouteImport } from "./routes/admin/live-now"
import { Route as AdminMessagesRouteRouteImport } from "./routes/admin/messages/route"
import { Route as AdminNumbersRouteImport } from "./routes/admin/numbers"
import { Route as AdminPeopleRouteImport } from "./routes/admin/people"
import { Route as AdminRepAnalyticsRouteImport } from "./routes/admin/rep-analytics"
import { Route as AdminResumeRouteImport } from "./routes/admin/resume"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"
import { Route as ListenCallIdRouteImport } from "./routes/listen.$callId"
import { Route as AdminAiIndexRouteImport } from "./routes/admin/ai/index"
import { Route as AdminAiImportsRouteImport } from "./routes/admin/ai/imports"
import { Route as AdminBillingIndexRouteImport } from "./routes/admin/billing/index"
import { Route as AdminBillingUsageRouteImport } from "./routes/admin/billing/usage"
import { Route as AdminCallingDispositionsRouteImport } from "./routes/admin/calling/dispositions"
import { Route as AdminCallingParallelDialRouteImport } from "./routes/admin/calling/parallel-dial"
import { Route as AdminCallingPoliciesRouteImport } from "./routes/admin/calling/policies"
import { Route as AdminCallingVoicemailDropsRouteImport } from "./routes/admin/calling/voicemail-drops"
import { Route as AdminCallsIndexRouteImport } from "./routes/admin/calls/index"
import { Route as AdminCallsCallIdRouteImport } from "./routes/admin/calls/$callId"
import { Route as AdminCampaignsIndexRouteImport } from "./routes/admin/campaigns/index"
import { Route as AdminCampaignsCampaignIdRouteImport } from "./routes/admin/campaigns/$campaignId"
import { Route as AdminCoachingPeriodIdRouteImport } from "./routes/admin/coaching/$periodId"
import { Route as AdminIntegrationsIndexRouteImport } from "./routes/admin/integrations/index"
import { Route as AdminIntegrationsKindRouteImport } from "./routes/admin/integrations/$kind"
import { Route as AdminIntegrationsEmailSendingRouteImport } from "./routes/admin/integrations/email-sending"
import { Route as AdminMessagesIndexRouteImport } from "./routes/admin/messages/index"
import { Route as AdminMessagesConversationIdRouteImport } from "./routes/admin/messages/$conversationId"
import { Route as AdminMessagesOptOutsRouteImport } from "./routes/admin/messages/opt-outs"
import { Route as AdminMessagesTemplatesRouteImport } from "./routes/admin/messages/templates"
import { Route as AdminMessagesTextingRouteImport } from "./routes/admin/messages/texting"
import { Route as AdminPhoneSystem911RouteImport } from "./routes/admin/phone-system/911"
import { Route as AdminPhoneSystemVoicemailRouteImport } from "./routes/admin/phone-system/voicemail"
import { Route as AdminSupportIndexRouteImport } from "./routes/admin/support/index"
import { Route as AdminSupportReportIdRouteImport } from "./routes/admin/support/$reportId"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformHandoffRoute = PlatformHandoffRouteImport.update({
  id: "/platform-handoff",
  path: "/platform-handoff",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: "/reset",
  path: "/reset",
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AdminRoute,
} as any)
const AdminDataRoute = AdminDataRouteImport.update({
  id: "/data",
  path: "/data",
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailMarketingRoute = AdminEmailMarketingRouteImport.update({
  id: "/email-marketing",
  path: "/email-marketing",
  getParentRoute: () => AdminRoute,
} as any)
const AdminLiveNowRoute = AdminLiveNowRouteImport.update({
  id: "/live-now",
  path: "/live-now",
  getParentRoute: () => AdminRoute,
} as any)
const AdminMessagesRouteRoute = AdminMessagesRouteRouteImport.update({
  id: "/messages",
  path: "/messages",
  getParentRoute: () => AdminRoute,
} as any)
const AdminNumbersRoute = AdminNumbersRouteImport.update({
  id: "/numbers",
  path: "/numbers",
  getParentRoute: () => AdminRoute,
} as any)
const AdminPeopleRoute = AdminPeopleRouteImport.update({
  id: "/people",
  path: "/people",
  getParentRoute: () => AdminRoute,
} as any)
const AdminRepAnalyticsRoute = AdminRepAnalyticsRouteImport.update({
  id: "/rep-analytics",
  path: "/rep-analytics",
  getParentRoute: () => AdminRoute,
} as any)
const AdminResumeRoute = AdminResumeRouteImport.update({
  id: "/resume",
  path: "/resume",
  getParentRoute: () => AdminRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const ListenCallIdRoute = ListenCallIdRouteImport.update({
  id: "/listen/$callId",
  path: "/listen/$callId",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiIndexRoute = AdminAiIndexRouteImport.update({
  id: "/ai/",
  path: "/ai/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiImportsRoute = AdminAiImportsRouteImport.update({
  id: "/ai/imports",
  path: "/ai/imports",
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingIndexRoute = AdminBillingIndexRouteImport.update({
  id: "/billing/",
  path: "/billing/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingUsageRoute = AdminBillingUsageRouteImport.update({
  id: "/billing/usage",
  path: "/billing/usage",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCallingDispositionsRoute =
  AdminCallingDispositionsRouteImport.update({
    id: "/calling/dispositions",
    path: "/calling/dispositions",
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCallingParallelDialRoute =
  AdminCallingParallelDialRouteImport.update({
    id: "/calling/parallel-dial",
    path: "/calling/parallel-dial",
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCallingPoliciesRoute = AdminCallingPoliciesRouteImport.update({
  id: "/calling/policies",
  path: "/calling/policies",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCallingVoicemailDropsRoute =
  AdminCallingVoicemailDropsRouteImport.update({
    id: "/calling/voicemail-drops",
    path: "/calling/voicemail-drops",
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCallsIndexRoute = AdminCallsIndexRouteImport.update({
  id: "/calls/",
  path: "/calls/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCallsCallIdRoute = AdminCallsCallIdRouteImport.update({
  id: "/calls/$callId",
  path: "/calls/$callId",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCampaignsIndexRoute = AdminCampaignsIndexRouteImport.update({
  id: "/campaigns/",
  path: "/campaigns/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCampaignsCampaignIdRoute =
  AdminCampaignsCampaignIdRouteImport.update({
    id: "/campaigns/$campaignId",
    path: "/campaigns/$campaignId",
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCoachingPeriodIdRoute = AdminCoachingPeriodIdRouteImport.update({
  id: "/coaching/$periodId",
  path: "/coaching/$periodId",
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsIndexRoute = AdminIntegrationsIndexRouteImport.update({
  id: "/integrations/",
  path: "/integrations/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsKindRoute = AdminIntegrationsKindRouteImport.update({
  id: "/integrations/$kind",
  path: "/integrations/$kind",
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsEmailSendingRoute =
  AdminIntegrationsEmailSendingRouteImport.update({
    id: "/integrations/email-sending",
    path: "/integrations/email-sending",
    getParentRoute: () => AdminRoute,
  } as any)
const AdminMessagesIndexRoute = AdminMessagesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminMessagesRouteRoute,
} as any)
const AdminMessagesConversationIdRoute =
  AdminMessagesConversationIdRouteImport.update({
    id: "/$conversationId",
    path: "/$conversationId",
    getParentRoute: () => AdminMessagesRouteRoute,
  } as any)
const AdminMessagesOptOutsRoute = AdminMessagesOptOutsRouteImport.update({
  id: "/opt-outs",
  path: "/opt-outs",
  getParentRoute: () => AdminMessagesRouteRoute,
} as any)
const AdminMessagesTemplatesRoute = AdminMessagesTemplatesRouteImport.update({
  id: "/templates",
  path: "/templates",
  getParentRoute: () => AdminMessagesRouteRoute,
} as any)
const AdminMessagesTextingRoute = AdminMessagesTextingRouteImport.update({
  id: "/texting",
  path: "/texting",
  getParentRoute: () => AdminMessagesRouteRoute,
} as any)
const AdminPhoneSystem911Route = AdminPhoneSystem911RouteImport.update({
  id: "/phone-system/911",
  path: "/phone-system/911",
  getParentRoute: () => AdminRoute,
} as any)
const AdminPhoneSystemVoicemailRoute =
  AdminPhoneSystemVoicemailRouteImport.update({
    id: "/phone-system/voicemail",
    path: "/phone-system/voicemail",
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSupportIndexRoute = AdminSupportIndexRouteImport.update({
  id: "/support/",
  path: "/support/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportReportIdRoute = AdminSupportReportIdRouteImport.update({
  id: "/support/$reportId",
  path: "/support/$reportId",
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/account": typeof AccountRoute
  "/admin": typeof AdminRouteWithChildren
  "/platform-handoff": typeof PlatformHandoffRoute
  "/reset": typeof ResetRoute
  "/signin": typeof SigninRoute
  "/signup": typeof SignupRoute
  "/admin/messages": typeof AdminMessagesRouteRouteWithChildren
  "/admin/audit": typeof AdminAuditRoute
  "/admin/data": typeof AdminDataRoute
  "/admin/email-marketing": typeof AdminEmailMarketingRoute
  "/admin/live-now": typeof AdminLiveNowRoute
  "/admin/numbers": typeof AdminNumbersRoute
  "/admin/people": typeof AdminPeopleRoute
  "/admin/rep-analytics": typeof AdminRepAnalyticsRoute
  "/admin/resume": typeof AdminResumeRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/listen/$callId": typeof ListenCallIdRoute
  "/admin/": typeof AdminIndexRoute
  "/admin/ai/imports": typeof AdminAiImportsRoute
  "/admin/billing/usage": typeof AdminBillingUsageRoute
  "/admin/calling/dispositions": typeof AdminCallingDispositionsRoute
  "/admin/calling/parallel-dial": typeof AdminCallingParallelDialRoute
  "/admin/calling/policies": typeof AdminCallingPoliciesRoute
  "/admin/calling/voicemail-drops": typeof AdminCallingVoicemailDropsRoute
  "/admin/calls/$callId": typeof AdminCallsCallIdRoute
  "/admin/campaigns/$campaignId": typeof AdminCampaignsCampaignIdRoute
  "/admin/coaching/$periodId": typeof AdminCoachingPeriodIdRoute
  "/admin/integrations/$kind": typeof AdminIntegrationsKindRoute
  "/admin/integrations/email-sending": typeof AdminIntegrationsEmailSendingRoute
  "/admin/messages/$conversationId": typeof AdminMessagesConversationIdRoute
  "/admin/messages/opt-outs": typeof AdminMessagesOptOutsRoute
  "/admin/messages/templates": typeof AdminMessagesTemplatesRoute
  "/admin/messages/texting": typeof AdminMessagesTextingRoute
  "/admin/phone-system/911": typeof AdminPhoneSystem911Route
  "/admin/phone-system/voicemail": typeof AdminPhoneSystemVoicemailRoute
  "/admin/support/$reportId": typeof AdminSupportReportIdRoute
  "/admin/ai/": typeof AdminAiIndexRoute
  "/admin/billing/": typeof AdminBillingIndexRoute
  "/admin/calls/": typeof AdminCallsIndexRoute
  "/admin/campaigns/": typeof AdminCampaignsIndexRoute
  "/admin/integrations/": typeof AdminIntegrationsIndexRoute
  "/admin/messages/": typeof AdminMessagesIndexRoute
  "/admin/support/": typeof AdminSupportIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/account": typeof AccountRoute
  "/platform-handoff": typeof PlatformHandoffRoute
  "/reset": typeof ResetRoute
  "/signin": typeof SigninRoute
  "/signup": typeof SignupRoute
  "/admin/audit": typeof AdminAuditRoute
  "/admin/data": typeof AdminDataRoute
  "/admin/email-marketing": typeof AdminEmailMarketingRoute
  "/admin/live-now": typeof AdminLiveNowRoute
  "/admin/numbers": typeof AdminNumbersRoute
  "/admin/people": typeof AdminPeopleRoute
  "/admin/rep-analytics": typeof AdminRepAnalyticsRoute
  "/admin/resume": typeof AdminResumeRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/listen/$callId": typeof ListenCallIdRoute
  "/admin": typeof AdminIndexRoute
  "/admin/ai/imports": typeof AdminAiImportsRoute
  "/admin/billing/usage": typeof AdminBillingUsageRoute
  "/admin/calling/dispositions": typeof AdminCallingDispositionsRoute
  "/admin/calling/parallel-dial": typeof AdminCallingParallelDialRoute
  "/admin/calling/policies": typeof AdminCallingPoliciesRoute
  "/admin/calling/voicemail-drops": typeof AdminCallingVoicemailDropsRoute
  "/admin/calls/$callId": typeof AdminCallsCallIdRoute
  "/admin/campaigns/$campaignId": typeof AdminCampaignsCampaignIdRoute
  "/admin/coaching/$periodId": typeof AdminCoachingPeriodIdRoute
  "/admin/integrations/$kind": typeof AdminIntegrationsKindRoute
  "/admin/integrations/email-sending": typeof AdminIntegrationsEmailSendingRoute
  "/admin/messages/$conversationId": typeof AdminMessagesConversationIdRoute
  "/admin/messages/opt-outs": typeof AdminMessagesOptOutsRoute
  "/admin/messages/templates": typeof AdminMessagesTemplatesRoute
  "/admin/messages/texting": typeof AdminMessagesTextingRoute
  "/admin/phone-system/911": typeof AdminPhoneSystem911Route
  "/admin/phone-system/voicemail": typeof AdminPhoneSystemVoicemailRoute
  "/admin/support/$reportId": typeof AdminSupportReportIdRoute
  "/admin/ai": typeof AdminAiIndexRoute
  "/admin/billing": typeof AdminBillingIndexRoute
  "/admin/calls": typeof AdminCallsIndexRoute
  "/admin/campaigns": typeof AdminCampaignsIndexRoute
  "/admin/integrations": typeof AdminIntegrationsIndexRoute
  "/admin/messages": typeof AdminMessagesIndexRoute
  "/admin/support": typeof AdminSupportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/account": typeof AccountRoute
  "/admin": typeof AdminRouteWithChildren
  "/platform-handoff": typeof PlatformHandoffRoute
  "/reset": typeof ResetRoute
  "/signin": typeof SigninRoute
  "/signup": typeof SignupRoute
  "/admin/messages": typeof AdminMessagesRouteRouteWithChildren
  "/admin/audit": typeof AdminAuditRoute
  "/admin/data": typeof AdminDataRoute
  "/admin/email-marketing": typeof AdminEmailMarketingRoute
  "/admin/live-now": typeof AdminLiveNowRoute
  "/admin/numbers": typeof AdminNumbersRoute
  "/admin/people": typeof AdminPeopleRoute
  "/admin/rep-analytics": typeof AdminRepAnalyticsRoute
  "/admin/resume": typeof AdminResumeRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/listen/$callId": typeof ListenCallIdRoute
  "/admin/": typeof AdminIndexRoute
  "/admin/ai/imports": typeof AdminAiImportsRoute
  "/admin/billing/usage": typeof AdminBillingUsageRoute
  "/admin/calling/dispositions": typeof AdminCallingDispositionsRoute
  "/admin/calling/parallel-dial": typeof AdminCallingParallelDialRoute
  "/admin/calling/policies": typeof AdminCallingPoliciesRoute
  "/admin/calling/voicemail-drops": typeof AdminCallingVoicemailDropsRoute
  "/admin/calls/$callId": typeof AdminCallsCallIdRoute
  "/admin/campaigns/$campaignId": typeof AdminCampaignsCampaignIdRoute
  "/admin/coaching/$periodId": typeof AdminCoachingPeriodIdRoute
  "/admin/integrations/$kind": typeof AdminIntegrationsKindRoute
  "/admin/integrations/email-sending": typeof AdminIntegrationsEmailSendingRoute
  "/admin/messages/$conversationId": typeof AdminMessagesConversationIdRoute
  "/admin/messages/opt-outs": typeof AdminMessagesOptOutsRoute
  "/admin/messages/templates": typeof AdminMessagesTemplatesRoute
  "/admin/messages/texting": typeof AdminMessagesTextingRoute
  "/admin/phone-system/911": typeof AdminPhoneSystem911Route
  "/admin/phone-system/voicemail": typeof AdminPhoneSystemVoicemailRoute
  "/admin/support/$reportId": typeof AdminSupportReportIdRoute
  "/admin/ai/": typeof AdminAiIndexRoute
  "/admin/billing/": typeof AdminBillingIndexRoute
  "/admin/calls/": typeof AdminCallsIndexRoute
  "/admin/campaigns/": typeof AdminCampaignsIndexRoute
  "/admin/integrations/": typeof AdminIntegrationsIndexRoute
  "/admin/messages/": typeof AdminMessagesIndexRoute
  "/admin/support/": typeof AdminSupportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/account"
    | "/admin"
    | "/platform-handoff"
    | "/reset"
    | "/signin"
    | "/signup"
    | "/admin/messages"
    | "/admin/audit"
    | "/admin/data"
    | "/admin/email-marketing"
    | "/admin/live-now"
    | "/admin/numbers"
    | "/admin/people"
    | "/admin/rep-analytics"
    | "/admin/resume"
    | "/auth/callback"
    | "/listen/$callId"
    | "/admin/"
    | "/admin/ai/imports"
    | "/admin/billing/usage"
    | "/admin/calling/dispositions"
    | "/admin/calling/parallel-dial"
    | "/admin/calling/policies"
    | "/admin/calling/voicemail-drops"
    | "/admin/calls/$callId"
    | "/admin/campaigns/$campaignId"
    | "/admin/coaching/$periodId"
    | "/admin/integrations/$kind"
    | "/admin/integrations/email-sending"
    | "/admin/messages/$conversationId"
    | "/admin/messages/opt-outs"
    | "/admin/messages/templates"
    | "/admin/messages/texting"
    | "/admin/phone-system/911"
    | "/admin/phone-system/voicemail"
    | "/admin/support/$reportId"
    | "/admin/ai/"
    | "/admin/billing/"
    | "/admin/calls/"
    | "/admin/campaigns/"
    | "/admin/integrations/"
    | "/admin/messages/"
    | "/admin/support/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/account"
    | "/platform-handoff"
    | "/reset"
    | "/signin"
    | "/signup"
    | "/admin/audit"
    | "/admin/data"
    | "/admin/email-marketing"
    | "/admin/live-now"
    | "/admin/numbers"
    | "/admin/people"
    | "/admin/rep-analytics"
    | "/admin/resume"
    | "/auth/callback"
    | "/listen/$callId"
    | "/admin"
    | "/admin/ai/imports"
    | "/admin/billing/usage"
    | "/admin/calling/dispositions"
    | "/admin/calling/parallel-dial"
    | "/admin/calling/policies"
    | "/admin/calling/voicemail-drops"
    | "/admin/calls/$callId"
    | "/admin/campaigns/$campaignId"
    | "/admin/coaching/$periodId"
    | "/admin/integrations/$kind"
    | "/admin/integrations/email-sending"
    | "/admin/messages/$conversationId"
    | "/admin/messages/opt-outs"
    | "/admin/messages/templates"
    | "/admin/messages/texting"
    | "/admin/phone-system/911"
    | "/admin/phone-system/voicemail"
    | "/admin/support/$reportId"
    | "/admin/ai"
    | "/admin/billing"
    | "/admin/calls"
    | "/admin/campaigns"
    | "/admin/integrations"
    | "/admin/messages"
    | "/admin/support"
  id:
    | "__root__"
    | "/"
    | "/account"
    | "/admin"
    | "/platform-handoff"
    | "/reset"
    | "/signin"
    | "/signup"
    | "/admin/messages"
    | "/admin/audit"
    | "/admin/data"
    | "/admin/email-marketing"
    | "/admin/live-now"
    | "/admin/numbers"
    | "/admin/people"
    | "/admin/rep-analytics"
    | "/admin/resume"
    | "/auth/callback"
    | "/listen/$callId"
    | "/admin/"
    | "/admin/ai/imports"
    | "/admin/billing/usage"
    | "/admin/calling/dispositions"
    | "/admin/calling/parallel-dial"
    | "/admin/calling/policies"
    | "/admin/calling/voicemail-drops"
    | "/admin/calls/$callId"
    | "/admin/campaigns/$campaignId"
    | "/admin/coaching/$periodId"
    | "/admin/integrations/$kind"
    | "/admin/integrations/email-sending"
    | "/admin/messages/$conversationId"
    | "/admin/messages/opt-outs"
    | "/admin/messages/templates"
    | "/admin/messages/texting"
    | "/admin/phone-system/911"
    | "/admin/phone-system/voicemail"
    | "/admin/support/$reportId"
    | "/admin/ai/"
    | "/admin/billing/"
    | "/admin/calls/"
    | "/admin/campaigns/"
    | "/admin/integrations/"
    | "/admin/messages/"
    | "/admin/support/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AdminRoute: typeof AdminRouteWithChildren
  PlatformHandoffRoute: typeof PlatformHandoffRoute
  ResetRoute: typeof ResetRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  ListenCallIdRoute: typeof ListenCallIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account": {
      id: "/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/platform-handoff": {
      id: "/platform-handoff"
      path: "/platform-handoff"
      fullPath: "/platform-handoff"
      preLoaderRoute: typeof PlatformHandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset": {
      id: "/reset"
      path: "/reset"
      fullPath: "/reset"
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signin": {
      id: "/signin"
      path: "/signin"
      fullPath: "/signin"
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signup": {
      id: "/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/": {
      id: "/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/audit": {
      id: "/admin/audit"
      path: "/audit"
      fullPath: "/admin/audit"
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/data": {
      id: "/admin/data"
      path: "/data"
      fullPath: "/admin/data"
      preLoaderRoute: typeof AdminDataRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/email-marketing": {
      id: "/admin/email-marketing"
      path: "/email-marketing"
      fullPath: "/admin/email-marketing"
      preLoaderRoute: typeof AdminEmailMarketingRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/live-now": {
      id: "/admin/live-now"
      path: "/live-now"
      fullPath: "/admin/live-now"
      preLoaderRoute: typeof AdminLiveNowRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/messages": {
      id: "/admin/messages"
      path: "/messages"
      fullPath: "/admin/messages"
      preLoaderRoute: typeof AdminMessagesRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/numbers": {
      id: "/admin/numbers"
      path: "/numbers"
      fullPath: "/admin/numbers"
      preLoaderRoute: typeof AdminNumbersRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/people": {
      id: "/admin/people"
      path: "/people"
      fullPath: "/admin/people"
      preLoaderRoute: typeof AdminPeopleRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/rep-analytics": {
      id: "/admin/rep-analytics"
      path: "/rep-analytics"
      fullPath: "/admin/rep-analytics"
      preLoaderRoute: typeof AdminRepAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/resume": {
      id: "/admin/resume"
      path: "/resume"
      fullPath: "/admin/resume"
      preLoaderRoute: typeof AdminResumeRouteImport
      parentRoute: typeof AdminRoute
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/listen/$callId": {
      id: "/listen/$callId"
      path: "/listen/$callId"
      fullPath: "/listen/$callId"
      preLoaderRoute: typeof ListenCallIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/ai/": {
      id: "/admin/ai/"
      path: "/ai"
      fullPath: "/admin/ai/"
      preLoaderRoute: typeof AdminAiIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/ai/imports": {
      id: "/admin/ai/imports"
      path: "/ai/imports"
      fullPath: "/admin/ai/imports"
      preLoaderRoute: typeof AdminAiImportsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/billing/": {
      id: "/admin/billing/"
      path: "/billing"
      fullPath: "/admin/billing/"
      preLoaderRoute: typeof AdminBillingIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/billing/usage": {
      id: "/admin/billing/usage"
      path: "/billing/usage"
      fullPath: "/admin/billing/usage"
      preLoaderRoute: typeof AdminBillingUsageRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calling/dispositions": {
      id: "/admin/calling/dispositions"
      path: "/calling/dispositions"
      fullPath: "/admin/calling/dispositions"
      preLoaderRoute: typeof AdminCallingDispositionsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calling/parallel-dial": {
      id: "/admin/calling/parallel-dial"
      path: "/calling/parallel-dial"
      fullPath: "/admin/calling/parallel-dial"
      preLoaderRoute: typeof AdminCallingParallelDialRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calling/policies": {
      id: "/admin/calling/policies"
      path: "/calling/policies"
      fullPath: "/admin/calling/policies"
      preLoaderRoute: typeof AdminCallingPoliciesRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calling/voicemail-drops": {
      id: "/admin/calling/voicemail-drops"
      path: "/calling/voicemail-drops"
      fullPath: "/admin/calling/voicemail-drops"
      preLoaderRoute: typeof AdminCallingVoicemailDropsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calls/": {
      id: "/admin/calls/"
      path: "/calls"
      fullPath: "/admin/calls/"
      preLoaderRoute: typeof AdminCallsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calls/$callId": {
      id: "/admin/calls/$callId"
      path: "/calls/$callId"
      fullPath: "/admin/calls/$callId"
      preLoaderRoute: typeof AdminCallsCallIdRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/campaigns/": {
      id: "/admin/campaigns/"
      path: "/campaigns"
      fullPath: "/admin/campaigns/"
      preLoaderRoute: typeof AdminCampaignsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/campaigns/$campaignId": {
      id: "/admin/campaigns/$campaignId"
      path: "/campaigns/$campaignId"
      fullPath: "/admin/campaigns/$campaignId"
      preLoaderRoute: typeof AdminCampaignsCampaignIdRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/coaching/$periodId": {
      id: "/admin/coaching/$periodId"
      path: "/coaching/$periodId"
      fullPath: "/admin/coaching/$periodId"
      preLoaderRoute: typeof AdminCoachingPeriodIdRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/integrations/": {
      id: "/admin/integrations/"
      path: "/integrations"
      fullPath: "/admin/integrations/"
      preLoaderRoute: typeof AdminIntegrationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/integrations/$kind": {
      id: "/admin/integrations/$kind"
      path: "/integrations/$kind"
      fullPath: "/admin/integrations/$kind"
      preLoaderRoute: typeof AdminIntegrationsKindRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/integrations/email-sending": {
      id: "/admin/integrations/email-sending"
      path: "/integrations/email-sending"
      fullPath: "/admin/integrations/email-sending"
      preLoaderRoute: typeof AdminIntegrationsEmailSendingRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/messages/": {
      id: "/admin/messages/"
      path: "/"
      fullPath: "/admin/messages/"
      preLoaderRoute: typeof AdminMessagesIndexRouteImport
      parentRoute: typeof AdminMessagesRouteRoute
    }
    "/admin/messages/$conversationId": {
      id: "/admin/messages/$conversationId"
      path: "/$conversationId"
      fullPath: "/admin/messages/$conversationId"
      preLoaderRoute: typeof AdminMessagesConversationIdRouteImport
      parentRoute: typeof AdminMessagesRouteRoute
    }
    "/admin/messages/opt-outs": {
      id: "/admin/messages/opt-outs"
      path: "/opt-outs"
      fullPath: "/admin/messages/opt-outs"
      preLoaderRoute: typeof AdminMessagesOptOutsRouteImport
      parentRoute: typeof AdminMessagesRouteRoute
    }
    "/admin/messages/templates": {
      id: "/admin/messages/templates"
      path: "/templates"
      fullPath: "/admin/messages/templates"
      preLoaderRoute: typeof AdminMessagesTemplatesRouteImport
      parentRoute: typeof AdminMessagesRouteRoute
    }
    "/admin/messages/texting": {
      id: "/admin/messages/texting"
      path: "/texting"
      fullPath: "/admin/messages/texting"
      preLoaderRoute: typeof AdminMessagesTextingRouteImport
      parentRoute: typeof AdminMessagesRouteRoute
    }
    "/admin/phone-system/911": {
      id: "/admin/phone-system/911"
      path: "/phone-system/911"
      fullPath: "/admin/phone-system/911"
      preLoaderRoute: typeof AdminPhoneSystem911RouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/phone-system/voicemail": {
      id: "/admin/phone-system/voicemail"
      path: "/phone-system/voicemail"
      fullPath: "/admin/phone-system/voicemail"
      preLoaderRoute: typeof AdminPhoneSystemVoicemailRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/support/": {
      id: "/admin/support/"
      path: "/support"
      fullPath: "/admin/support/"
      preLoaderRoute: typeof AdminSupportIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/support/$reportId": {
      id: "/admin/support/$reportId"
      path: "/support/$reportId"
      fullPath: "/admin/support/$reportId"
      preLoaderRoute: typeof AdminSupportReportIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminMessagesRouteRouteChildren {
  AdminMessagesConversationIdRoute: typeof AdminMessagesConversationIdRoute
  AdminMessagesOptOutsRoute: typeof AdminMessagesOptOutsRoute
  AdminMessagesTemplatesRoute: typeof AdminMessagesTemplatesRoute
  AdminMessagesTextingRoute: typeof AdminMessagesTextingRoute
  AdminMessagesIndexRoute: typeof AdminMessagesIndexRoute
}

const AdminMessagesRouteRouteChildren: AdminMessagesRouteRouteChildren = {
  AdminMessagesConversationIdRoute: AdminMessagesConversationIdRoute,
  AdminMessagesOptOutsRoute: AdminMessagesOptOutsRoute,
  AdminMessagesTemplatesRoute: AdminMessagesTemplatesRoute,
  AdminMessagesTextingRoute: AdminMessagesTextingRoute,
  AdminMessagesIndexRoute: AdminMessagesIndexRoute,
}

const AdminMessagesRouteRouteWithChildren =
  AdminMessagesRouteRoute._addFileChildren(AdminMessagesRouteRouteChildren)

interface AdminRouteChildren {
  AdminMessagesRouteRoute: typeof AdminMessagesRouteRouteWithChildren
  AdminAuditRoute: typeof AdminAuditRoute
  AdminDataRoute: typeof AdminDataRoute
  AdminEmailMarketingRoute: typeof AdminEmailMarketingRoute
  AdminLiveNowRoute: typeof AdminLiveNowRoute
  AdminNumbersRoute: typeof AdminNumbersRoute
  AdminPeopleRoute: typeof AdminPeopleRoute
  AdminRepAnalyticsRoute: typeof AdminRepAnalyticsRoute
  AdminResumeRoute: typeof AdminResumeRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAiImportsRoute: typeof AdminAiImportsRoute
  AdminBillingUsageRoute: typeof AdminBillingUsageRoute
  AdminCallingDispositionsRoute: typeof AdminCallingDispositionsRoute
  AdminCallingParallelDialRoute: typeof AdminCallingParallelDialRoute
  AdminCallingPoliciesRoute: typeof AdminCallingPoliciesRoute
  AdminCallingVoicemailDropsRoute: typeof AdminCallingVoicemailDropsRoute
  AdminCallsCallIdRoute: typeof AdminCallsCallIdRoute
  AdminCampaignsCampaignIdRoute: typeof AdminCampaignsCampaignIdRoute
  AdminCoachingPeriodIdRoute: typeof AdminCoachingPeriodIdRoute
  AdminIntegrationsKindRoute: typeof AdminIntegrationsKindRoute
  AdminIntegrationsEmailSendingRoute: typeof AdminIntegrationsEmailSendingRoute
  AdminPhoneSystem911Route: typeof AdminPhoneSystem911Route
  AdminPhoneSystemVoicemailRoute: typeof AdminPhoneSystemVoicemailRoute
  AdminSupportReportIdRoute: typeof AdminSupportReportIdRoute
  AdminAiIndexRoute: typeof AdminAiIndexRoute
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
  AdminCallsIndexRoute: typeof AdminCallsIndexRoute
  AdminCampaignsIndexRoute: typeof AdminCampaignsIndexRoute
  AdminIntegrationsIndexRoute: typeof AdminIntegrationsIndexRoute
  AdminSupportIndexRoute: typeof AdminSupportIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminMessagesRouteRoute: AdminMessagesRouteRouteWithChildren,
  AdminAuditRoute: AdminAuditRoute,
  AdminDataRoute: AdminDataRoute,
  AdminEmailMarketingRoute: AdminEmailMarketingRoute,
  AdminLiveNowRoute: AdminLiveNowRoute,
  AdminNumbersRoute: AdminNumbersRoute,
  AdminPeopleRoute: AdminPeopleRoute,
  AdminRepAnalyticsRoute: AdminRepAnalyticsRoute,
  AdminResumeRoute: AdminResumeRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminAiImportsRoute: AdminAiImportsRoute,
  AdminBillingUsageRoute: AdminBillingUsageRoute,
  AdminCallingDispositionsRoute: AdminCallingDispositionsRoute,
  AdminCallingParallelDialRoute: AdminCallingParallelDialRoute,
  AdminCallingPoliciesRoute: AdminCallingPoliciesRoute,
  AdminCallingVoicemailDropsRoute: AdminCallingVoicemailDropsRoute,
  AdminCallsCallIdRoute: AdminCallsCallIdRoute,
  AdminCampaignsCampaignIdRoute: AdminCampaignsCampaignIdRoute,
  AdminCoachingPeriodIdRoute: AdminCoachingPeriodIdRoute,
  AdminIntegrationsKindRoute: AdminIntegrationsKindRoute,
  AdminIntegrationsEmailSendingRoute: AdminIntegrationsEmailSendingRoute,
  AdminPhoneSystem911Route: AdminPhoneSystem911Route,
  AdminPhoneSystemVoicemailRoute: AdminPhoneSystemVoicemailRoute,
  AdminSupportReportIdRoute: AdminSupportReportIdRoute,
  AdminAiIndexRoute: AdminAiIndexRoute,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
  AdminCallsIndexRoute: AdminCallsIndexRoute,
  AdminCampaignsIndexRoute: AdminCampaignsIndexRoute,
  AdminIntegrationsIndexRoute: AdminIntegrationsIndexRoute,
  AdminSupportIndexRoute: AdminSupportIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AdminRoute: AdminRouteWithChildren,
  PlatformHandoffRoute: PlatformHandoffRoute,
  ResetRoute: ResetRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  ListenCallIdRoute: ListenCallIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
